module.exports = __webpack_public_path__ + "static/img/4.4166dbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/4.png
// module id = Mtnz
// module chunks = 0